import { render } from "./LeftSidebar.vue?vue&type=template&id=da870f18"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ecommunity\\vms-admin.sg\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__